import {
  validateDocument as publicValidateDocument,
  convertToRicosDocument as publicConvertToRicosDocument,
  convertFromRicosDocument as publicConvertFromRicosDocument,
} from './ricos-v1-service-services.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

/** @internal */
export const validateDocument: MaybeContext<
  BuildRESTFunction<typeof publicValidateDocument> &
    typeof publicValidateDocument
> = /*#__PURE__*/ createRESTModule(publicValidateDocument);
/** @internal */
export const convertToRicosDocument: MaybeContext<
  BuildRESTFunction<typeof publicConvertToRicosDocument> &
    typeof publicConvertToRicosDocument
> = /*#__PURE__*/ createRESTModule(publicConvertToRicosDocument);
/** @internal */
export const convertFromRicosDocument: MaybeContext<
  BuildRESTFunction<typeof publicConvertFromRicosDocument> &
    typeof publicConvertFromRicosDocument
> = /*#__PURE__*/ createRESTModule(publicConvertFromRicosDocument);

export {
  NodeType,
  WidthType,
  PluginContainerDataAlignment,
  Type,
  Target,
  TextAlignment,
  LineStyle,
  Width,
  Alignment,
  ViewMode,
  LayoutType,
  Orientation,
  Crop,
  ThumbnailsAlignment,
  GIFType,
  Source,
  Position,
  MapType,
  ViewRole,
  VoteRole,
  PollLayoutType,
  PollLayoutDirection,
  BackgroundType,
  DecorationType,
  FontType,
  AppType,
  InitialExpandedItems,
  Direction,
  VerticalAlignment,
  NullValue,
  TargetFormat,
} from './ricos-v1-service-services.universal.js';
export {
  RicosService,
  ValidateDocumentRequest,
  ValidateDocumentResponse,
  RicosDocumentViolation,
  RichContent,
  Node,
  NodeDataOneOf,
  NodeStyle,
  ButtonData,
  Border,
  Colors,
  PluginContainerData,
  PluginContainerDataWidth,
  PluginContainerDataWidthDataOneOf,
  Spoiler,
  Height,
  Styles,
  Link,
  LinkDataOneOf,
  Rel,
  CodeBlockData,
  TextStyle,
  DividerData,
  FileData,
  FileSource,
  FileSourceDataOneOf,
  PDFSettings,
  GalleryData,
  Media,
  Image,
  Video,
  Item,
  ItemDataOneOf,
  GalleryOptions,
  Layout,
  ItemStyle,
  Thumbnails,
  GIFData,
  GIF,
  HeadingData,
  HTMLData,
  HTMLDataDataOneOf,
  ImageData,
  StylesBorder,
  ImageDataStyles,
  LinkPreviewData,
  LinkPreviewDataStyles,
  MapData,
  MapSettings,
  ParagraphData,
  PollData,
  Permissions,
  Option,
  Settings,
  PollLayout,
  OptionLayout,
  Gradient,
  Background,
  BackgroundBackgroundOneOf,
  PollDesign,
  OptionDesign,
  Poll,
  PollDataLayout,
  Design,
  TextData,
  Decoration,
  DecorationDataOneOf,
  AnchorData,
  ColorData,
  LinkData,
  MentionData,
  FontSizeData,
  SpoilerData,
  AppEmbedData,
  AppEmbedDataAppDataOneOf,
  BookingData,
  EventData,
  VideoData,
  PlaybackOptions,
  EmbedData,
  Oembed,
  CollapsibleListData,
  TableData,
  Dimensions,
  TableCellData,
  CellStyle,
  BorderColors,
  ListValue,
  AudioData,
  OrderedListData,
  BulletedListData,
  BlockquoteData,
  CaptionData,
  LayoutCellData,
  Metadata,
  DocumentStyle,
  TextNodeStyle,
  ConvertToRicosDocumentRequest,
  ConvertToRicosDocumentRequestSourceOneOf,
  RicosDocumentOptions,
  ConvertToRicosDocumentResponse,
  ConvertFromRicosDocumentRequest,
  ConvertFromRicosDocumentRequestOptionsOneOf,
  PlainTextOptions,
  ConvertFromRicosDocumentResponse,
  ConvertFromRicosDocumentResponseResultOneOf,
  ValidateDocumentOptions,
  ConvertToRicosDocumentOptions,
  ConvertToRicosDocumentOptionsSourceOneOf,
  ConvertFromRicosDocumentOptions,
  ConvertFromRicosDocumentOptionsOptionsOneOf,
} from './ricos-v1-service-services.universal.js';
export {
  NodeTypeWithLiterals,
  WidthTypeWithLiterals,
  PluginContainerDataAlignmentWithLiterals,
  TypeWithLiterals,
  TargetWithLiterals,
  TextAlignmentWithLiterals,
  LineStyleWithLiterals,
  WidthWithLiterals,
  AlignmentWithLiterals,
  ViewModeWithLiterals,
  LayoutTypeWithLiterals,
  OrientationWithLiterals,
  CropWithLiterals,
  ThumbnailsAlignmentWithLiterals,
  GIFTypeWithLiterals,
  SourceWithLiterals,
  PositionWithLiterals,
  MapTypeWithLiterals,
  ViewRoleWithLiterals,
  VoteRoleWithLiterals,
  PollLayoutTypeWithLiterals,
  PollLayoutDirectionWithLiterals,
  BackgroundTypeWithLiterals,
  DecorationTypeWithLiterals,
  FontTypeWithLiterals,
  AppTypeWithLiterals,
  InitialExpandedItemsWithLiterals,
  DirectionWithLiterals,
  VerticalAlignmentWithLiterals,
  NullValueWithLiterals,
  TargetFormatWithLiterals,
} from './ricos-v1-service-services.universal.js';
